<template>
  <div class="home">
    MERCADO FAILURE
  </div>
</template>

<script>
//import { useToast } from "vue-toastification";
//const toast = useToast();

export default {
  name: 'ViewMercadoFailure',
  mounted() {
    
  },
  data() {
    return {
      
    };
  },  
  methods: {
    
  },
  
};
</script>

<style scoped>

</style>
